import React from "react";
import StickyNav from "./StickyNav";
import Topbar from "./Topbar";
const Header = ({siteSettings}) => {
    return (
        <>
            {/* Header Start */}
            <header>
                <div className="hd-style1">
                    <Topbar siteSettings={siteSettings} />
                    {/* header Nav Menu Start */}
                    <StickyNav siteSettings={siteSettings}/>
                    {/* header Nav Menu End */}

                </div>
            </header>
            {/* Header End */}
        </>
    );
}

export default Header;